import { render, staticRenderFns } from "./Bundling.vue?vue&type=template&id=2601cd6f&"
import script from "./Bundling.vue?vue&type=script&lang=js&"
export * from "./Bundling.vue?vue&type=script&lang=js&"
import style0 from "./Bundling.vue?vue&type=style&index=0&id=2601cd6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QIcon,QCardActions});
